import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDividerModule } from '@angular/material/divider';
import { CoreModule } from "../core/core.module";
import { AdminRoutingModule } from "./admin-routing.module";
import { AdminLayoutComponent } from "./layout/admin-layout.component";
import { AdminSharedModule } from './_shared/admin-shared.module';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
    declarations: [
        AdminLayoutComponent,
    ],
    imports: [
        CommonModule,
        CoreModule,
        AdminSharedModule,
        MatDividerModule,
        AdminRoutingModule,
        PlatformModule,
        MatBadgeModule
    ]
})
export class AdminModule {}